export type FaqSegment = { href: string; text: string; type: 'link' } | { text: string; type: 'text' };

export type FaqEntry = {
  /** Plain-text version of the answer (used for FAQPage JSON-LD). */
  a: string;
  q: string;
  /**
   * Optional segmented form of the answer for JSX rendering.
   * When present, the UI renders these segments (with real anchor elements for `link` segments).
   * When absent, the plain `a` string is rendered directly.
   */
  segments?: ReadonlyArray<FaqSegment>;
};

export const FAQ_DATA: ReadonlyArray<FaqEntry> = [
  {
    a: 'A quarterly read on whether U.S. homeowners’ trust in the solar industry is improving, based on their real experiences with solar professionals.',
    q: 'What is the Aurora Solar Trust Signal?',
  },
  {
    a: 'The Aurora Solar Snapshot is our annual industry study, the big-picture “is there a problem?” The Aurora Solar Trust Signal is the lighter, quarterly consumer companion: “is it getting better, and where?”',
    q: 'How is it different from the Aurora Solar Snapshot?',
  },
  {
    a: 'Every quarter. The latest wave is always shown on this page, and our blog posts are refreshed each season against the newest data.',
    q: 'How often is it updated?',
  },
  {
    a: 'The quarterly Aurora Solar Trust Signal is fielded with Dynata (about 1,000 U.S. homeowners per wave). The annual Aurora Solar Snapshot is conducted by Coleman Parkes (1,112 homeowners in 2026).',
    q: 'Who runs the surveys?',
  },
  {
    a: 'We ask homeowners about their actual experiences with solar professionals, what built their confidence and what eroded it, and track those answers over time.',
    q: 'How do you measure “trust”?',
  },
  {
    a: 'Because the direction is the honest, reliable story. We measure the same way each season and report how trust is moving, rather than claiming a single precise figure.',
    q: 'Why show a trend instead of a single number?',
  },
  {
    a: '',
    q: 'Can I cite this data?',
    segments: [
      {
        text: 'Yes. Please attribute it to the Aurora Solar Trust Signal (quarterly, Dynata) or the Aurora Solar Snapshot 2026 (Coleman Parkes), as noted. Reporters and analysts can find the full industry dataset on ',
        type: 'text',
      },
      { href: 'https://aurorasolar.com/aurora-solar-snapshot/', text: 'the Aurora Solar Snapshot page', type: 'link' },
      { text: '.', type: 'text' },
    ],
  },
];
